<template>
    <div class="notes-menu__wrapper" v-bind:class="{ 
        'notes-menu--show': showMenu,
        'notes-menu--dossier': isdossier
    }">
        <button 
            class="notes-menu__button single-note__button--save" 
            v-bind:class="{ 'notes-menu__button--show': showMenu }"
            v-on:click="toggleMenu('all')">
                <div class="notes-menu__arrow"><i class="flaticon2-arrow"></i></div>
                <p> Notes <span class="notes-count">({{ notesCount }})</span></p>
        </button>
        <!-- Place it here, because of cloning functionality issue in  click-listener.js file ... -->
        <button
            v-if="addnotedata.extra.record_type === 'job_request'"
            class="notes-menu__button button--show-sourcing-tasks single-note__button--save" 
            v-bind:class="{ 'notes-menu__button--show': showMenu }"
            v-on:click="toggleMenu('sourcingTask')">
                <p> Sourcing tasks </p>
        </button>

        <notes-table-full
            v-bind:isstatus="isstatus"
            v-bind:statusdata="statusdata"
            v-bind:viewer="viewer"
            v-bind:typefilter="typefilter"
            v-bind:urlnotes="urlnotes"
            v-bind:filternotes="filternotes"
            v-bind:canaddnote="canaddnote"
            v-bind:addnotedata="addnotedata"
            v-bind:addnoterecordid="addnoterecordid"
            v-bind:noeditor="false"
            v-bind:candidatetypeoptions="candidatetypeoptions"
            v-bind:shownotetypefilters="true"
        ></notes-table-full>
    </div>
</template>

<script>
    import NotesTableFull from './talbe.vue'

    export default {
        props: [
            "isstatus",
            "statusdata",
            "viewer",
            "isdossier",
            "typefilter",
            "urlnotes",
            "filternotes",
            'canaddnote',
            'addnotedata',
            'addnoterecordid',
            'candidatetypeoptions'
        ],
        data: function(){ 
            return { 
                showMenu: false,
                notesCount: 0
            };
        },
        components: { NotesTableFull },
        watch: {
            notesCount: function(newVal,oldVal){ 
                $(`.notes-count`).each(function(index){ 
                    let count;
                    if(newVal > 99){ count = `99+` }else{ count = newVal };
                    this.innerHTML = `(${count})`;
                });
            }
        },
        methods: { 
            toggleMenu: function(type) {
                // get note type dropdown component reference
                const childrenTypeSelectComponent = this.$children[0].$children[0].$children[0];

                if (this.showMenu) {
                    if (type === 'sourcingTask') {
                        childrenTypeSelectComponent.selectOption({ 'name': 'Source', 'id': 'sourcing_task' });
                        return;
                    }
                }
                
                if (type === 'all') {
                    if (this.showMenu) {
                        childrenTypeSelectComponent.selectOption({ 'name': 'all', 'id': null });
                    } else {
                        if (this.addnotedata.extra.record_type === 'job_request') {
                            childrenTypeSelectComponent.selectOption({ 'name': 'all (notes and tasks)', 'id': 'notes_and_tasks' });
                        }
                    }
                } else if (type === 'sourcingTask') {
                    childrenTypeSelectComponent.selectOption({ 'name': 'Source', 'id': 'sourcing_task' });
                }

                // console.log($.merge($(`.note-button-copy-small`),$(`.note-button-copy-mid`)));
                $.merge($(`.note-button-copy-small`),$(`.note-button-copy-mid`)).each(function(index){ this.setButtonState() });
                this.showMenu = !this.showMenu; 
                document.body.style.overflow = this.showMenu ? 'hidden' : 'auto';
            } 
        }
    }
</script>